export class Contact {
  idContact?: number;
  emailUser?: string;
  name: string;
  title: string;
  department: string;
  email: string;
  phone: string;
  company: string;
  tags?: string;
  pdfpassword: string;
}


/**
 * Returns a array of unique tags present in the tag string
 * @param str An optional pipe-separated string with the tags (accepts empty string and invalid types)
 */
export function getTagArrayFromString(str?: string): string[] {
  if (typeof str !== 'string' || str.trim().length <= 0) {
    return [];
  }
  if (!str.includes(' ')) {
    return [str];
  }
  const parts = str.split(' ').filter(tag => tag);
  return Array.from(new Set(parts));
}
